<template>
  <div>
    <div class="row d-flex align-items-center" style="margin-top: 10px">
      <div class="col-12">
        <h2 v-if="propView == 'completo'">Indicações</h2>

        <div v-if="propView == 'usuario'" class="form-group row">
          <label class="col-sm-12 col-form-label">Renovações</label>
          <div class="col-sm-12 d-flex justify-content-center">
            <Combo
              :itens="[
                { id: '1', nome: '1' },
                { id: '2', nome: '2' },
                {
                  id: '3',
                  nome: '3',
                },
                { id: '4', nome: '4' },
                { id: '5', nome: '5' },
                { id: '6', nome: '6' },
                { id: '7', nome: '7' },
                { id: '8', nome: '8' },
                { id: '9', nome: '9' },
                { id: '10', nome: '10' },
                { id: '11', nome: '11' },
                { id: '12', nome: '12' },
              ]"
              v-model="renovacoes"
              style="max-width: 200px"
              @change="$emit('renovacoes', renovacoes)"
            />
          </div>
        </div>

        <h5>
          <span class="text-secondary">Link para divulgação</span><br />
          <a target="_blank" :href="linkIndicacao">{{ linkIndicacao }}</a>
        </h5>

        <div style="margin-top: 40px">
          <div style="margin-bottom: 20px">
            <button
              type="button"
              v-bind:class="{
                'btn-dark': indicacaoTab == 0,
                'btn-outline-dark': indicacaoTab !== 0,
              }"
              @click="
                indicacaoTab = 0;
                carregarIndicacoes();
              "
              class="btn btn-sm"
            >
              {{ tabIndicacaoLabel(0) }}</button
            ><button
              type="button"
              class="btn btn-sm"
              v-bind:class="{
                'btn-dark': indicacaoTab == -1,
                'btn-outline-dark': indicacaoTab !== -1,
              }"
              @click="
                indicacaoTab = -1;
                carregarIndicacoes();
              "
              style="margin-left: 10px"
            >
              {{ tabIndicacaoLabel(-1) }}
            </button>
          </div>
          <h5
            v-if="indicacoes.length == 0"
            class="text-secondary"
            style="margin-top: 30px"
          >
            Nenhuma indicação no momento
          </h5>
          <div
            v-for="(indicacao, indicacaoIndex) in indicacoes"
            :key="indicacao._id"
            :item="indicacao"
            class="list-group-item"
          >
            <div class="row">
              <div class="col col-md-12">
                <div class="d-flex w-100 justify-content-between">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1" style="display: block">
                      {{ indicacao.email }}
                    </h6>
                    <!---->
                  </div>
                  <h6>
                    <span style="display: none" class="badge badge-secondary"
                      >Aguardando</span
                    >
                    # {{ indicacoes.length - indicacaoIndex }}
                  </h6>
                </div>
                <div>
                  <p
                    class="
                      text-secondary
                      textoResumo
                      d-flex
                      w-100
                      justify-content-between
                    "
                  >
                    <small
                      >Lançamento:
                      {{ formatDate(indicacao.dataLancamento) }}</small
                    ><small></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Combo from "../components/Combo.vue";

export default {
  name: "ListIndicacoes",
  components: { Combo },
  props: {
    propView: { type: String, default: "completo" },
    renovacoes: { type: String, default: "1" },
    usuario: { type: String, default: "" },
    site: { type: String, default: "" },
  },
  computed: {
    linkIndicacao() {
      var linkId = this.$sessao ? this.$sessao.usuario._id : "";

      if (this.usuario !== "") {
        linkId = this.usuario;
        return (
          "https://" +
          (this.site == "Bll"
            ? "bllsport.com"
            : this.site == "Weddbets"
            ? "weddbets.com"
            : window.location.hostname) +
          "/i/" +
          linkId
        );
      } else {
        return "https://" + window.location.hostname + "/i/" + linkId;
      }
    },
  },
  methods: {
    async carregarIndicacoes() {
      this.indicacoes = [];

      const response = await api.get(
        "/plano/indicacoes?mes=" +
          this.indicacaoTab +
          (this.filtroUsuarioIndicacao !== ""
            ? "&usuarioIndicacao=" + this.filtroUsuarioIndicacao
            : "")
      );
      var responseResult = response.data;
      if (!responseResult.erro) {
        this.indicacoes = responseResult.itens;
      }
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    emailMaskHide(email) {
      return util.emailMaskHide(email);
    },
    tabIndicacaoLabel(mes) {
      const mesNome = [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro",
      ];

      var data = new Date();
      data.setDate(15);
      data.setMonth(data.getMonth() + mes);

      return mesNome[data.getMonth()] + "/" + data.getFullYear();
    },
  },
  mounted() {
    /*if (this.$site == "Weddbets") {
      this.carregarIndicacoes();
    }*/
  },
  data: function () {
    return {
      indicacoes: [],
      indicacaoTab: 0,
      filtroUsuarioIndicacao: "",
    };
  },
};
</script>

<style>
</style>
